import React, { Component } from 'react';
import { Input } from 'antd';

import withFormItem from 'components/hocs/withFormItem';

@withFormItem
export default class InputComponent extends Component {
    static defaultProps = {
        rows: 4,
        autosize: false,
    }

    onChange = (e) => {
        const { field: { name }, form: { setFieldValue } } = this.props;

        setFieldValue(
            name,
            e.target.value
        );
    }

    render() {
        const { field: { name, value } } = this.props;
        const { autosize, rows, placeholder, disabled } = this.props;

        return (
            <Input.TextArea
                autosize={autosize}
                rows={rows}
                name={name}
                value={value}
                onChange={this.onChange}
                placeholder={placeholder}
                disabled={disabled}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/Text.js